export function callForAllElement(
  array: any[],
  callback: (value: any, index: number, array: any[]) => unknown
) {
  Promise.all(array.map(callback));
}
